import { booleanAttribute } from "#ce/utils/props";
import { props as textFieldProps } from "#ce/components/SpTextField/props.js";

// We had bugs in the past, where the props were mutatated. Apply Object.freeze() to prevent this.
export const props = Object.freeze({
  ...textFieldProps,
  /**
   * Clears the input field when the clear button is clicked.
   * This will render a clear button on the right side of the input field.
   * This will only be visible when the input field is not empty.
   *
   * @type {Boolean|String}
   * @default false
   */
  clearable: booleanAttribute(),
  /**
   * Leaves out the search icon.
   *
   * @type {Boolean|String}
   * @default false
   */
  noIcon: booleanAttribute(),
  /**
   * Places the search icon at "start" or "end"; a clearable field with a value replaces the end icon with its clear button.
   *
   * @type {String}
   * @default "start"
   * @values start, end
   * @storybook-control select
   */
  iconPosition: {
    type: String,
    default: "start",
    validator: (value) => ["start", "end"].includes(value),
  },
  placeholder: {
    ...textFieldProps.placeholder,
    default: "Search",
  },
  /**
   * Name of the `sp-icon` drawn in the prepend slot's default content.
   *
   * @type {String}
   * @default "search-filled"
   */
  glassIcon: {
    type: String,
    default: "search-filled",
  },
});
